import mainAxios from "../api/mainAxios";

export const fetchInitialData = () => async (dispatch) => {
  try {
    const response = await mainAxios.get("api/deep-search-initial-data");

    dispatch({ type: "LOAD_INITIAL_DATA", payload: response.data });
  } catch (error) {
    console.error("Error fetching initial data:", error);
  }
};
